<template>
  <router-view />
</template>

<script>
export default {
  name: 'club-page',
};
</script>
